import { Step } from 'react-joyride';
import { TourIds } from '../consts';
import { AppRoute } from '../../../router/Routing';
import { TourReturnType, ToursSharedTargets } from '../Tours';

const tourId = TourIds.assistantReplacement;
const useTourAssistantReplacement = (): TourReturnType => {
    return {
        id: tourId,
        label: 'Advanced Assistant has been merged into Basic',
        data: {
            steps: [
                {
                    target: '#' + ToursSharedTargets.tourContainer,
                    title: 'Assistant update',
                    content:
                        'The Advanced Assistant has been merged into Basic. All advanced features are still available - you’ll find them under the ⚙️ Settings menu. Enjoy a simpler, more streamlined experience. ✨',
                    placement: 'center',
                    data: {
                        pathname: AppRoute.basicAssistant,
                    },
                },
            ] as Step[],
        },
    };
};

export default useTourAssistantReplacement;
